/*
==============================================================================
MANTRAROMA CUSTOM
Version: 1.0.0
Datum: 14.09.2026
Zweck: Variantenwechsel über Edelstein-Swatches auf allgemeinen Collections.
Ändert beim Klick Bild, Titel, Preis und Produktlink der Produktkarte.
assets/main.js des Symmetry-Themes bleibt unverändert.
==============================================================================
*/

(() => {
  const swatchSelector =
    '.product-block-options__item[data-mantraroma-variant-id]';

  function findSwatch(target) {
    return target instanceof Element ? target.closest(swatchSelector) : null;
  }

  /*
  ==============================================================================
  MANTRAROMA CUSTOM
  Version: 1.1.0
  Datum: 15.09.2026
  Zweck: Neues Variantenbild vorladen und erst nach vollständigem Laden einsetzen,
  damit Kettenanhänger beim Bildwechsel nicht kurz flackern.
  ==============================================================================
  */
  function updateCardImage(card, image, imageSrc, imageSrcset) {
    const requestId = `${Date.now()}-${Math.random()}`;
    card.dataset.mantraromaImageRequest = requestId;

    const preload = new Image();
    let committed = false;

    const commit = () => {
      if (
        committed ||
        card.dataset.mantraromaImageRequest !== requestId
      ) {
        return;
      }

      committed = true;

      if (imageSrcset) {
        image.srcset = imageSrcset;
      }

      image.src = imageSrc;
    };

    preload.decoding = 'async';
    preload.sizes = image.sizes || image.getAttribute('sizes') || '';

    if (imageSrcset) {
      preload.srcset = imageSrcset;
    }

    preload.src = imageSrc;
    preload.addEventListener('load', commit, { once: true });

    if (preload.complete && preload.naturalWidth > 0) {
      if (typeof preload.decode === 'function') {
        preload.decode().then(commit).catch(commit);
      } else {
        commit();
      }
    }
  }

  function updateCard(swatch) {
    const card = swatch.closest('product-block');

    if (!card) {
      return;
    }

    const variantId = swatch.dataset.mantraromaVariantId;
    const title = swatch.dataset.mantraromaTitle;
    const priceHtml = swatch.dataset.mantraromaPriceHtml;
    const imageSrc = swatch.dataset.mantraromaImageSrc;
    const imageSrcset = swatch.dataset.mantraromaImageSrcset;

    const activeImageContainer =
      card.querySelector('.product-block__image--active') ||
      card.querySelector('.product-block__image');

    const image = activeImageContainer?.querySelector('img');

    if (image && imageSrc) {
      updateCardImage(
        card,
        image,
        imageSrc,
        imageSrcset
      );
    }

    const titleElement = card.querySelector('.product-block__title');

    if (titleElement && title) {
      titleElement.textContent = title;
    }

    const priceElement = card.querySelector('.product-price--block');

    if (priceElement && priceHtml) {
      priceElement.innerHTML = priceHtml;
    }

    if (variantId) {
      card
        .querySelectorAll('a.product-link, a.quickbuy-toggle')
        .forEach((link) => {
          const url = new URL(link.href, window.location.origin);

          url.searchParams.set('variant', variantId);
          link.href = `${url.pathname}${url.search}${url.hash}`;
          link.rel = 'nofollow';
        });
    }

    const row = swatch.closest('.product-block-options');

    row
      ?.querySelectorAll('.product-block-options__item')
      .forEach((item) => {
        item.classList.toggle(
          'product-block-options__item--mantraroma-active',
          item === swatch
        );
      });
  }

  document.addEventListener(
    'mouseenter',
    (event) => {
      if (findSwatch(event.target)) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const swatch = findSwatch(event.target);

      if (!swatch) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      updateCard(swatch);
    },
    true
  );
})();